// rfid
import confirmBox from '@/components/confirm.js'
import CenturyleadDevice from '@/api/device/centurylead.js'
import {i18n} from '@/api/i18n'
import { deviceSelect, getCenturyleadDeviceSysConfig } from '@/api/device/util.js'

const rfid = {
  state: {
    deviceList:[
      {
        label: 'centurylead',
        code: 'centurylead',
        DeviceClass: CenturyleadDevice,
        getSysConfig: getCenturyleadDeviceSysConfig,
        id:'1',
        sysConfig: null,
        pageKey: '',     // 当前占用该设备的页面 key
        instance: null            // 当前设备实例
      }
    ],
  },
  getters: {
    deviceList: state => state.deviceList,
    deviceConfig: state => deviceCode => {
      let device = state.deviceList.find(item => item.code === deviceCode)
      return device && device.sysConfig
    },
    deviceInstance: state => deviceCode => {
      const device = state.deviceList.find(item => item.code === deviceCode)
      return device.instance
    }
  },
  mutations: {
    SET_DEVICE_INFO(state, options) {
      state.deviceList.forEach(device => {
        if(device.code === options.deviceCode){
          if(options.pageKey) device.pageKey = options.pageKey
          if(options.instance) device.instance = options.instance
          if(options.sysConfig) device.sysConfig = options.sysConfig
        }
      });
    }
  },
  actions:{
    async DEVICE_INIT({commit, getters, dispatch}, options = {}){
      const devicePageKey = options.devicePageKey
      let deviceCode = options.deviceCode
       // 如果只有一个设备，则直接选定唯一的设备
      const deviceList = getters.deviceList
      if (deviceList.length === 1) deviceCode = deviceList[0].code
      // 没有指定 && 设备有多个，则弹窗选择
      if (!deviceCode && deviceList.length > 1) {
          let res = await deviceSelect(deviceList).catch(e =>  console.log(e))
          if(!res)  return null
          deviceCode = res
      }
      let device = deviceList.find(item => item.code === deviceCode)
      if (device.pageKey && devicePageKey !== device.pageKey) {
          // 不同页面使用同一设备，需用户确认是否切换
          const confirmed = await confirmBox( i18n.t('rfidUsed'), null, null, true)
          // 用户取消切换，保持原页面占用
          if (!confirmed) return null
      }
      if (!device || !device.DeviceClass) {
        console.error('[RFID-SDK] 未找到对应的 RFID 设备实现:', deviceCode)
        return { errMessage: '[RFID-SDK] 未找到对应的 RFID 设备实现' }
      }
      if (!devicePageKey) {
        console.error('[RFID-SDK] 页面标识参数必传:', deviceCode, devicePageKey)
        return { errMessage: '[RFID-SDK] 页面标识参数必传' }
      }
      let deviceConfig = getters.deviceConfig(deviceCode)
      if(!deviceConfig) deviceConfig = await device.getSysConfig()
      if(!deviceConfig || !deviceConfig.ruleStr) return { notConfig: true }
      commit('SET_DEVICE_INFO', {deviceCode, sysConfig: deviceConfig, pageKey: devicePageKey})
      if (device.DeviceClass) {
          let instance = new device.DeviceClass({
              ...deviceConfig,
              onmessage: options.onmessage,
              onchange: options.onchange
          })
          commit('SET_DEVICE_INFO',{deviceCode, instance})
          return {instance, deviceCode, deviceConfig}
      }
      return  { errMessage: '[RFID-SDK] 设备初始化失败' }
    },
    async DEVICE_DESTROY({getters, commit}, {deviceCode, devicePageKey}){
      const deviceList = getters.deviceList
      const device = deviceList.find(item => item.code === deviceCode && item.pageKey === devicePageKey)
      if(device){
        await device.instance.close()
        commit('SET_DEVICE_INFO', {deviceCode, pageKey: null, instance: null})
      }
    }
  }
}

export default rfid






